var F = "var(--default-font)";
export var supportModalStyles = {
    modalRoot: {
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: { xs: "12px", sm: "24px" },
        outline: "none",
    },
    modalCard: {
        width: "100%",
        maxWidth: 460,
        maxHeight: { xs: "calc(100dvh - 24px)", md: "calc(100dvh - 48px)" },
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        borderRadius: "18px",
        border: "1px solid rgba(255,255,255,0.08)",
        background: "#0f0f12",
        boxShadow: "0 20px 60px rgba(0,0,0,0.85)",
    },
    header: {
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: "20px",
        py: "14px",
        borderBottom: "1px solid rgba(255,255,255,0.07)",
    },
    headerTitle: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
    },
    headerIconBox: {
        width: 36,
        height: 36,
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255,184,1,0.1)",
        border: "1px solid rgba(255,184,1,0.18)",
        flexShrink: 0,
    },
    headerIcon: {
        fontSize: 18,
        color: "rgb(255,184,1)",
    },
    headerText: {
        fontSize: 15,
        fontWeight: 600,
        color: "#fff",
        fontFamily: F,
        lineHeight: 1,
    },
    closeButton: {
        width: 32,
        height: 32,
        borderRadius: "8px",
        color: "rgba(255,255,255,0.4)",
        border: "1px solid rgba(255,255,255,0.08)",
        backgroundColor: "rgba(255,255,255,0.04)",
        transition: "all 0.18s ease",
        "&:hover": {
            color: "#fff",
            backgroundColor: "rgba(255,255,255,0.08)",
            borderColor: "rgba(255,255,255,0.14)",
        },
    },
    content: {
        flex: 1,
        overflowY: "auto",
        px: "20px",
        pt: "18px",
        pb: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        scrollbarWidth: "thin",
        scrollbarColor: "#3f3f46 transparent",
    },
    sectionLabel: {
        fontSize: 11,
        fontWeight: 700,
        color: "rgba(255,255,255,0.35)",
        fontFamily: F,
        textTransform: "uppercase",
        letterSpacing: "0.06em",
        mb: "8px",
    },
    emailCard: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        p: "10px 12px",
        borderRadius: "10px",
        border: "1px solid rgba(255,255,255,0.07)",
        backgroundColor: "rgba(255,255,255,0.04)",
    },
    emailIconBox: {
        width: 36,
        height: 36,
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "rgb(255,184,1)",
        backgroundColor: "rgba(255,184,1,0.08)",
        border: "1px solid rgba(255,184,1,0.14)",
        flexShrink: 0,
    },
    emailCaption: {
        fontSize: 11,
        color: "rgba(255,255,255,0.38)",
        fontFamily: F,
        lineHeight: 1,
    },
    emailValue: {
        fontSize: 13,
        fontWeight: 600,
        color: "#fff",
        fontFamily: F,
        mt: "3px",
        wordBreak: "break-all",
    },
    helperText: {
        fontSize: 12,
        color: "rgba(255,255,255,0.3)",
        fontFamily: F,
        lineHeight: 1.5,
        mt: "8px",
    },
    textField: {
        "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            color: "#fff",
            backgroundColor: "rgba(255,255,255,0.03)",
            fontSize: "14px",
            fontFamily: F,
            lineHeight: 1.6,
            transition: "background 0.18s ease",
            "& fieldset": {
                borderColor: "rgba(255,255,255,0.09)",
                borderWidth: "1px",
            },
            "&:hover fieldset": {
                borderColor: "rgba(255,255,255,0.16)",
            },
            "&.Mui-focused": {
                backgroundColor: "rgba(255,255,255,0.05)",
            },
            "&.Mui-focused fieldset": {
                borderColor: "rgb(255,184,1)",
                borderWidth: "1.5px",
            },
        },
        "& .MuiInputBase-input": {
            padding: "12px 14px",
            fontFamily: F,
        },
        "& .MuiInputBase-input::placeholder": {
            color: "rgba(255,255,255,0.25)",
            opacity: 1,
        },
    },
    actionRow: {
        display: "flex",
        gap: "8px",
        pt: "4px",
    },
    cancelBtnSx: {
        height: 38,
        px: "18px",
        borderRadius: "10px",
        fontSize: 13,
        fontWeight: 500,
        fontFamily: F,
    },
};
export var submitButtonSx = {
    height: 38,
    flex: 1,
    borderRadius: "10px",
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "var(--default-font)",
    color: "#0a0800",
    backgroundColor: "rgb(255,184,1)",
    border: "1px solid rgb(255,184,1)",
    transition: "all 0.18s ease",
    "&:hover": {
        backgroundColor: "rgb(255,200,50)",
        borderColor: "rgb(255,200,50)",
        boxShadow: "0 4px 16px rgba(255,184,1,0.28)",
    },
    "&.Mui-disabled": {
        backgroundColor: "rgba(255,255,255,0.06)",
        borderColor: "rgba(255,255,255,0.07)",
        color: "rgba(255,255,255,0.22)",
        boxShadow: "none",
    },
};
export var getFeedbackAlertSx = function (tone) { return ({
    borderRadius: "10px",
    padding: "10px 14px",
    backgroundColor: tone === "success" ? "rgba(34,197,94,0.07)" : "rgba(248,113,113,0.07)",
    color: "#fff",
    fontSize: "13px",
    fontFamily: "var(--default-font)",
    border: "1px solid ".concat(tone === "success" ? "rgba(34,197,94,0.18)" : "rgba(248,113,113,0.18)"),
    "& .MuiAlert-icon": {
        color: tone === "success" ? "#22c55e" : "#f87171",
        fontSize: 18,
    },
}); };
